<template>
<v-container fluid>
    <v-row cols="12">
        <v-col sm="2">
            <v-img 
                width="62"
                height="62"
                src="https://via.placeholder.com/62?text=Logo"
            ></v-img>
        </v-col>
        <v-col sm="7" class="center flex-column">
            <div class="text-xl">
                {{company.legal_name}}
            </div>
        </v-col>
        <v-col sm="3" class="center flex-column">
            <router-link :to="`/company/${employerId}`" class="uppercase" >View Profile</router-link>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "ProfileEmployerCard",
    mounted () {
        if (this.companyDataURL && !this.company.legal_name) {
            this.getCompanyData(this.companyDataURL)
        }
    },
    watch: {
        companyDataURL(newURL, ) {
            this.getCompanyData(newURL);
        }
    },
    props: {
        companyDataURL: '',
        employerId: 0,
    },
    methods: {
        getCompanyData (companyDataURL) {
            if (this.companyDataURL !== '') {
                const url = `${this.$store.getters.baseURL}${companyDataURL}`
                axios({
                    method: 'get',
                    url: url,
                    headers: {
                        'Authorization': `Token ${this.$store.state.userToken}`
                    }
                })
                .then(res => {
                    this.company = res.data;
                })
                .catch(err => {
                    console.error(err)
                }) 
            }
        }
    },
    data () {
        return {
            company: {
                legal_name: '',
                id: 0
            }
        }
    }
}
</script>

<style scoped>
.center {
    display: flex;
    justify-content: center;
}

.flex-column {
    flex-direction: column;
}
</style>